var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapGeoSiNoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffb642",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 11h-2.56c-.462-4.164-3.775-7.478-7.94-7.941V.5c0-.276-.224-.5-.5-.5h-1c-.276 0-.5.224-.5.5v2.559C6.835 3.522 3.522 6.836 3.059 11H.5c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5h2.559c.463 4.164 3.776 7.478 7.941 7.941V23.5c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5v-2.559c4.165-.463 7.478-3.777 7.941-7.941H23.5c.276 0 .5-.224.5-.5v-1c0-.276-.224-.5-.5-.5zM12 19c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGeoSiNoBg);
export default __webpack_public_path__ + "static/media/map-geo-si-no-bg.4b3aa2c5.svg";
export { ForwardRef as ReactComponent };